const binding = { modules: {}, dataActions: {} };

    (binding.modules['fabrikam'] = {
        c: () => require('partner/themes/fabrikam/fabrikam.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','content-block','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'fabrikam',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'fabrikam.theme.settings.json',
        md: 'src/themes/fabrikam'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };